module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_photowedding-4ee38ab4a2d60affa36be97e4033fa74.jpg";